

















import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import Enums from '@/lib/enums'
import appconst from '@/lib/appconst';

@Component
export default class WeightInput extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    customShopName: string = "";


    async save() {
        var shopid = this.$store.state.authorizationShop.shopid;
        await this.$store.dispatch({
            type: 'authorizationShop/customShopName',
            data: { shopId: shopid, customShopName: this.customShopName }
        });
        (this.$refs.packForm as any).resetFields();
        this.$emit('save-success');
        this.$emit('input', false);

    }

    cancel() {
        (this.$refs.packForm as any).resetFields();
        this.$emit('input', false);
    }
    visibleChange(value: boolean) {
        var id = this.$store.state.backmainlandorder.orderNumber;
        console.log(id);
        if (!value) {
            this.$emit('input', value);
        } else {

        }
    }
    created() {

    }
}
